import { render } from "./NewTicket.vue?vue&type=template&id=08f38487&scoped=true&ts=true"
import script from "./NewTicket.vue?vue&type=script&lang=ts"
export * from "./NewTicket.vue?vue&type=script&lang=ts"

import "./NewTicket.vue?vue&type=style&index=0&id=08f38487&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f38487"]])

export default __exports__